module.exports = __webpack_public_path__ + "static/media/77.dcd487a4.png";